import { useRef } from "react";

// VillaFlow "Selected Property" badge — rendered as SVG, downloadable by selected members.
export default function SelectedBadge({ propertyName = "", size = 300, downloadable = true }) {
  const svgRef = useRef(null);

  const svgMarkup = (name) => `
<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600">
  <rect width="600" height="600" fill="#0B1F3A"/>
  <rect x="30" y="30" width="540" height="540" fill="none" stroke="#C6A15B" stroke-width="1.5"/>
  <rect x="44" y="44" width="512" height="512" fill="none" stroke="#C6A15B" stroke-opacity="0.35" stroke-width="1"/>
  <text x="300" y="150" text-anchor="middle" fill="#FFFFFF" font-family="Georgia, 'Cormorant Garamond', serif" font-size="70" letter-spacing="1">VillaFlow</text>
  <path d="M120 195 C 210 175, 250 215, 300 195 S 400 175, 480 195" fill="none" stroke="#C6A15B" stroke-width="4" stroke-linecap="round"/>
  <text x="300" y="235" text-anchor="middle" fill="#C6A15B" font-family="Arial, sans-serif" font-size="15" letter-spacing="6">PRIVATE COLLECTION</text>
  <line x1="180" y1="300" x2="420" y2="300" stroke="#C6A15B" stroke-opacity="0.4" stroke-width="1"/>
  <text x="300" y="375" text-anchor="middle" fill="#F7F5EF" font-family="Georgia, serif" font-size="46" font-style="italic">Selected Property</text>
  ${name ? `<text x="300" y="440" text-anchor="middle" fill="#F7F5EF" fill-opacity="0.7" font-family="Arial, sans-serif" font-size="20" letter-spacing="2">${name.replace(/&/g, "&amp;").replace(/</g, "&lt;")}</text>` : ""}
  <text x="300" y="520" text-anchor="middle" fill="#C6A15B" font-family="Arial, sans-serif" font-size="13" letter-spacing="5">EVERY STAY. MORE VALUE.</text>
</svg>`;

  const download = () => {
    const blob = new Blob([svgMarkup(propertyName)], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `villaflow-selected-${(propertyName || "property").toLowerCase().replace(/\s+/g, "-")}.svg`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="inline-flex flex-col items-center gap-6" data-testid="selected-badge">
      <div ref={svgRef} style={{ width: size, height: size }} dangerouslySetInnerHTML={{ __html: svgMarkup(propertyName) }} className="[&>svg]:w-full [&>svg]:h-full border border-gold/20" />
      {downloadable && (
        <button onClick={download} className="border border-gold/50 hover:border-gold text-ivory hover:text-gold px-8 py-3 text-[11px] tracking-[0.2em] uppercase transition-colors duration-500" data-testid="download-badge-btn">
          Download Badge
        </button>
      )}
    </div>
  );
}
